import React from "react";
import { SEO } from "@bluefin/components";
import { Grid, Segment, Embed } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import "../style/book-now.css";

export default class BookNowPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.dreamhairstudionj.com/book-now/"}
        />
        <Grid
          className={"custom-page-book-now custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"fmfpdhcoagdnedfl"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"jhopmbhbllljeipe"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__37f659f9-a6ff-4acf-9a8a-7bbbe7dc4df2"}
                >
                  <Embed
                    url={"https://dreamhairstudio.glossgenius.com/services"}
                    autoplay={true}
                    defaultActive={true}
                    className={""}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 37340 }) {
      title
      seoTitle
      description
    }
  }
`;
